import React from "react";
import {ChartCustom} from "../../../../component/chartcustom/ChartCustom";
import useO2ActiveState from "./useO2ActiveState";
import {getMaxValue, getTicks} from "../../../../utils/utility";
import {useLanguageForShared} from "../../../../../shared/utils/languages/useLanguageForShared";

const O2ActiveState = ({states = []}) => {
    const {t} = useLanguageForShared()

    const {dataTable, dateTicks} = useO2ActiveState(states, t)
    const optionAdd = {
        colors: ['#F7A67E', '#5D62B5', '#29C3BE', '#F2726F'],
        seriesType: "bars",
        series: {3: {type: "line"}},
    }

    const vAxisAdd = {
        ticks: dateTicks
    }

    const formatters = dataTable[0].slice(1).map((ele, i) => (
        {
            type: "NumberFormat",
            column: i + 1,
            options: {
                decimalSymbol: ',',
                groupingSymbol: '.'
            }
        }
    ))

    return <ChartCustom dataTable={dataTable} options={optionAdd} chartType="ComboChart" vAxis={vAxisAdd}
                        formatters={formatters}/>
}

export default React.memo(O2ActiveState)
